import { render, staticRenderFns } from "./ContactSMSThread.vue?vue&type=template&id=48de4895&scoped=true"
import script from "./ContactSMSThread.vue?vue&type=script&lang=js"
export * from "./ContactSMSThread.vue?vue&type=script&lang=js"
import style0 from "./ContactSMSThread.vue?vue&type=style&index=0&id=48de4895&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48de4895",
  null
  
)

export default component.exports